<div class="component-container container">
    <div class="tab-content">
        <div class="clearfix">
            <div class="font-mont-semi-bold form-step-number">2</div>
            <div class="form-step-title">
                <h1 class="font-mont-semi-bold">Owner Information</h1>
            </div>
        </div>

        <div>
            <div class="row position-relative" *ngIf="!production">
                <button class="btn btn-primary btn-lg auto-populate"
                    (click)="onCompleteInformationClick(owner); $event.preventDefault();">
                    <em class="fa fa-check"></em>
                </button>
            </div>
            <form [formGroup]="owner.form" (ngSubmit)="onContinueClick($event);">
                <div class="owner-info-section clearfix">
                    <div class="form-row">
                        <div class="form-group col-sm-6">
                            <label for="sfirstName"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.firstName.errors }">First
                                Name*</label>
                            <input type="text" formControlName="firstName" class="form-control" id="sfirstName"
                                name="firstName"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.firstName.errors }">
                            <div *ngIf="submitted && owner.oForm.firstName.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.firstName.errors.required">
                                    First Name is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-6">
                            <label for="slastName"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.lastName.errors }">Last Name*</label>
                            <input type="text" formControlName="lastName" class="form-control" id="slastName"
                                name="lastName" [ngClass]="{ 'is-invalid': submitted && owner.oForm.lastName.errors }">
                            <div *ngIf="submitted && owner.oForm.lastName.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.lastName.errors.required">
                                    Last Name is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-6">
                            <label for="smobilePhoneNumber"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.mobilePhoneNumber.errors }">Mobile
                                Phone*</label>
                            <input type="text" formControlName="mobilePhoneNumber" class="form-control"
                                id="smobilePhoneNumber" placeholder="Home Phone Number" name="mobilePhoneNumber"
                                [showMaskTyped]="true" mask="(000) 000-0000"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.mobilePhoneNumber.errors }">
                            <div *ngIf="submitted && owner.oForm.mobilePhoneNumber.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.mobilePhoneNumber.errors.required">
                                    Mobile Phone Number is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-6">
                            <label for="semailAddress" class="font-mont-book"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.emailAddress.errors }">Email Address:
                                *</label>
                            <input type="email" formControlName="emailAddress" class="form-control" id="semailAddress"
                                name="emailAddress"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.emailAddress.errors }">
                            <div *ngIf="submitted && owner.oForm.emailAddress.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.emailAddress.errors.required">
                                    Email Address is required.
                                </div>
                                <div *ngIf="owner.oForm.emailAddress.errors.email">
                                    Invalid email address.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-6 bsDatepicker">
                            <label for="sbirthDate"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.birthDate.errors }">Date of
                                Birth*</label>
                            <input type="text" formControlName="birthDate" class="form-control" id="sbirthDate"
                                name="birthDate" [ngClass]="{ 'is-invalid': submitted && owner.oForm.birthDate.errors }"
                                bsDatepicker [maxDate]="maxAgeDate"
                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', isAnimated: true, containerClass: 'theme-dark-blue' }">
                            <div *ngIf="submitted && owner.oForm.birthDate.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.birthDate.errors.required">
                                    Birth Date is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-6">
                            <label for="ssocialSecurityNumber"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.socialSecurityNumber.errors }">Social
                                Security Number*</label>
                            <input type="text" formControlName="socialSecurityNumber" class="form-control"
                                id="ssocialSecurityNumber" name="socialSecurityNumber" [showMaskTyped]="true"
                                mask="000-00-0000"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.socialSecurityNumber.errors }">
                            <div *ngIf="submitted && owner.oForm.socialSecurityNumber.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.socialSecurityNumber.errors.required">
                                    Social Security Number is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-6">
                            <label for="sdoingBusinessAs"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.doingBusinessAs.errors }">Doing
                                Business As
                                (DBA): *
                                <div class="information-icon">
                                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                                    <div class="tool-tip-container">
                                        <span>This is what you call your business every day (it </span>
                                        <span>may be the same as your Business Name).</span>
                                    </div>
                                </div>
                            </label>
                            <input type="text" formControlName="doingBusinessAs" class="form-control"
                                id="sdoingBusinessAs" name="doingBusinessAs"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.doingBusinessAs.errors }">
                            <div *ngIf="submitted && owner.oForm.doingBusinessAs.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.doingBusinessAs.errors.required">
                                    DBA is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-6 bsDatepicker">
                            <label for="sbusinessStartDate"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.businessStartDate.errors }">Business
                                Start
                                Date:
                                *</label>
                            <input placeholder="mm/yyyy" type="text" formControlName="businessStartDate"
                                class="form-control" id="sbusinessStartDate" name="businessStartDate"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.businessStartDate.errors }"
                                bsDatepicker [maxDate]="today" [minDate]="minDate"
                                [bsConfig]="{ dateInputFormat: 'MM/YYYY', isAnimated: true, containerClass: 'theme-dark-blue', minMode: 'month'}">
                            <div *ngIf="submitted && owner.oForm.businessStartDate.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.businessStartDate.errors.required">
                                    Business Start Date is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-6">
                            <label for="shomeAddress"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.homeAddress.errors }">Home Street
                                Address*</label>
                            <input type="text" formControlName="homeAddress" class="form-control" id="shomeAddress"
                                name="homeAddress"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.homeAddress.errors }">
                            <div *ngIf="submitted && owner.oForm.homeAddress.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.homeAddress.errors.required">
                                    Home Street Address is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-6">
                            <label for="szipCode"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.zipCode.errors }">Zip*</label>
                            <input type="text" formControlName="zipCode" class="form-control" id="szipCode"
                                name="zipCode" (keyup)="onZipCodeKeyUpHandler(owner.oForm)"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.zipCode.errors }">
                            <div *ngIf="submitted && owner.oForm.zipCode.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.zipCode.errors.required">
                                    Zip Code is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-6 select">
                            <label for="scity"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.city.errors }">City*</label>
                            <select formControlName="city" id="scity" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.city.errors }">
                                <option *ngFor="let city of cities" [ngValue]="city">{{city}}</option>
                            </select>
                            <div *ngIf="submitted && owner.oForm.city.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.city.errors.required">
                                    City is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-2 select">
                            <label for="sstate"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.state.errors }">State*</label>
                            <select formControlName="state" id="sstate" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.state.errors }"
                                [attr.disabled]="true">
                                <option *ngFor="let state of states" [ngValue]="state.code">{{state.name}}</option>
                            </select>
                            <div *ngIf="submitted && owner.oForm.state.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.state.errors.required">
                                    State is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-4 select">
                            <label for="scounty"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.county.errors }">County:
                                *</label>
                            <select formControlName="county" class="form-control" id="scounty"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.county.errors }">
                                <option *ngFor="let county of counties" [ngValue]="county">{{county}}</option>
                            </select>
                            <div *ngIf="submitted && owner.oForm.county.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.county.errors.required">
                                    County is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-12">
                            <div class="sameAsBusiness-form">
                                <span>Business address same as Home address?</span>
                                <input type="radio" id="same-as-home-yes" value="true" (click)="onSetSameBusiness()"
                                    [formControl]="owner.oForm.sameAsBusiness" name="sameAsBusiness">
                                <label for="same-as-home-yes">Yes</label>
                                <input type="radio" id="same-as-home-no" value="false" (click)="onSetSameBusiness()"
                                    [formControl]="owner.oForm.sameAsBusiness" name="sameAsBusiness">
                                <label for="same-as-home-no">No</label>
                            </div>
                        </div>
                        <div class="form-group col-sm-6" [hidden]="owner.oForm.sameAsBusiness.value === 'true'">
                            <label for="sbusinessAddress"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.businessAddress.errors }">Business
                                Street
                                Address*</label>
                            <input type="text" formControlName="businessAddress" class="form-control"
                                id="sbusinessAddress" name="businessAddress"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.businessAddress.errors }">
                            <div *ngIf="submitted && owner.oForm.businessAddress.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.businessAddress.errors.required">
                                    Business Street Address is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-6" [hidden]="owner.oForm.sameAsBusiness.value === 'true'">
                            <label for="sbusinessZip"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.businessZip.errors }">Zip*</label>
                            <input type="text" formControlName="businessZip" class="form-control" id="sbusinessZip"
                                name="businessZip" (keyup)="onBusinessZipCodeKeyUpHandler(owner.oForm)"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.businessZip.errors }">
                            <div *ngIf="submitted && owner.oForm.businessZip.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.businessZip.errors.required">
                                    Business Zip Code is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-6 select" [hidden]="owner.oForm.sameAsBusiness.value === 'true'">
                            <label for="sbusinessCity"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.businessCity.errors }">City*</label>
                            <select formControlName="businessCity" id="sbusinessCity" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.businessCity.errors }">
                                <option *ngFor="let businessCity of businessCities" [ngValue]="businessCity">
                                    {{businessCity}}
                                </option>
                            </select>
                            <div *ngIf="submitted && owner.oForm.businessCity.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.businessCity.errors.required">
                                    Business City is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-2 select" [hidden]="owner.oForm.sameAsBusiness.value === 'true'">
                            <label for="sbusinessState"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.businessState.errors }">State*</label>
                            <select formControlName="businessState" id="sbusinessState" class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.businessState.errors }">
                                <option *ngFor="let businessState of businessStates" [ngValue]="businessState.code">
                                    {{businessState.name}}</option>
                            </select>
                            <div *ngIf="submitted && owner.oForm.businessState.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.businessState.errors.required">
                                    Business State is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-sm-4 select" [hidden]="owner.oForm.sameAsBusiness.value === 'true'">
                            <label for="sbusinessCounty"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.businessCounty.errors }">County:
                                *</label>
                            <select formControlName="businessCounty" class="form-control" id="sbusinessCounty"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.businessCounty.errors }">
                                <option *ngFor="let businessCounty of businessCounties" [ngValue]="businessCounty">
                                    {{businessCounty}}</option>
                            </select>
                            <div *ngIf="submitted && owner.oForm.businessCounty.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.businessCounty.errors.required">
                                    Business County is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-12 equipment-information-sub-title font-mont-regular">
                            Equipment Information
                        </div>
                        <div class="form-group col-md-12">
                            <label for="srequestedAmount"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.requestedAmount.errors }">Requested
                                Amount:
                                *</label>
                            <input type="text" formControlName="requestedAmount" class="form-control"
                                id="srequestedAmount" placeholder="$ " name="requestedAmount" prefix="$ "
                                mask="separator.2" thousandSeparator=","
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.requestedAmount.errors }">
                            <div *ngIf="submitted && owner.oForm.requestedAmount.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.requestedAmount.errors.required">
                                    Requested Amount is required.
                                </div>
                                <div *ngIf="owner.oForm.requestedAmount.errors.max">
                                    Your max requested amount is {{maxApplicationAmount | currency:'$ ':'code':'.0-0'}}.
                                </div>
                                <div *ngIf="owner.oForm.requestedAmount.errors.min">
                                    Your minimum requested amount is {{500 | currency:'$ ':'code':'.0-0'}}.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-12">
                            <label for="sequipmentDescription"
                                [ngClass]="{ 'color-red': submitted && owner.oForm.equipmentDescription.errors }">Equipment
                                Description:</label>
                            <textarea formControlName="equipmentDescription" class="form-control"
                                id="sequipmentDescription" rows="4" name="equipmentDescription"
                                [ngClass]="{ 'is-invalid': submitted && owner.oForm.equipmentDescription.errors }"></textarea>
                            <div *ngIf="submitted && owner.oForm.equipmentDescription.errors" class="invalid-feedback">
                                <div *ngIf="owner.oForm.equipmentDescription.errors.required">
                                    Equipment Description is required.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="owner-info-section clearfix">
                    <div class="form-row">
                        <div class="form-group col-sm-12 autorize">
                            <div>
                                <input type="checkbox" id="screditAuth" [formControl]="owner.oForm.creditAuth"
                                    name="creditAuth">
                                <div>
                                    By clicking this box, I authorize ClickLease LLC, and its assigns, on behalf of the
                                    Applicant, Co-Applicant and any proposed guarantor(s) provided herein (collectively
                                    the “Authorizing Parties”): (1) to obtain a personal consumer credit report on each
                                    of the Authorizing Parties, (2) authorize the release to ClickLease LLC of all
                                    credit and other information ClickLease LLC may request related to the Authorizing
                                    Parties; and (3) confirm that each of the Authorizing Parties has provided his/her
                                    Credit Consent.
                                </div>
                            </div>
                            <div>
                                <input type="checkbox" id="screditAuthTwo" [formControl]="owner.oForm.creditAuthTwo"
                                    name="creditAuthTwo">
                                <div>
                                    By clicking this box, I consent to receiving marketing communications from
                                    ClickLease at the telephone numbers I provided herein, which may be delivered by
                                    prerecorded message or autodialed telephone calls or text messages. I understand
                                    that my consent is not a condition of doing business with, or making purchase of any
                                    goods/services from, ClickLease. For text messages, message and data rates may
                                    apply. I understand I may opt-out of any telemarketing calls or text messages at any
                                    time by communicating my opt-out request during the call, emailing my opt-out
                                    request to ClickLease at <a href="mailto:CustomerCare@ClickLease.com">
                                        CustomerCare@ClickLease.com
                                    </a> with the subject line "Opt out"
                                    or texting STOP in response to the text message.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="form-row justify-content-between footer-buttons-container">
            <div class="form-group">
                <button type="submit" class="btn btn-secondary btn-lg col-md-12" (click)="onBackClick();">BACK</button>
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-primary btn-lg col-md-12" data-toggle="modal"
                    (click)="showVerifyInformationModal()" [disabled]="buttonContinueDisabled">
                    NEXT
                </button>
            </div>
        </div>
    </div>
    <app-what-makes-us-different></app-what-makes-us-different>
    <app-error-dialog [modalId]="errorId" [title]="errorTitle" [messageA]="errorMessageA" [messageB]="errorMessageB"
        [messageC]="errorMessageC" [messageBClass]="errorMessageBClass" [dialogClass]="'w600'">
    </app-error-dialog>
    <app-verify-information [$soleOwnersInfo]="owner" [isSole]="true" [token]="token" [owner]="owner"
        [statesIssued]="statesIssued" (submitClicked)="onContinueClick($event)" (backClicked)="onBackClick()">
    </app-verify-information>
</div>